import { RESET_ALL as RESET_ON_LOGOUT, danger } from 'redux-store/reducers/common-reducer';

import { API, get } from 'utils/api';
import { createReducer } from 'utils/redux';
import { __t, applyTranslations } from 'utils/language';

import type { Action, ThunkAction } from 'types';
import type { AgencyProfilesReduxState } from 'modules/influencers/types/AgencyProfile.type';
import { AgencyProfilesLoadingState } from 'modules/influencers/types/AgencyProfile.type';

applyTranslations(require('./influencerAgencyProfiles.i18n.json'));

const SET_LOADING_STATUS = 'influencerAgencyProfile/setLoadingState';
const SET_RESPONSE_DATA = 'influencerAgencyProfile/setResponseData';

const initialState: AgencyProfilesReduxState = {
  profiles: [],
  loadingStatus: AgencyProfilesLoadingState.initial
};

function setLoadingStatus(loadingStatus: AgencyProfilesLoadingState): Action {
  return {
    type: SET_LOADING_STATUS,
    payload: {
      loadingStatus
    }
  };
}

function setData(
  data: Array<any>
): Action {
  return {
    type: SET_RESPONSE_DATA,
    payload: {
      data
    }
  };
}

export function fetchAgencyInfluencers(profileId: number, isPaymentOverviewPage?: boolean): ThunkAction {
  return async (dispatch) => {
    try {
      dispatch(setLoadingStatus(AgencyProfilesLoadingState.loading));
      const url = API.END_POINTS[isPaymentOverviewPage ? 'ADMIN' : 'INFLUENCERS'].getInfluencersFromSameAgency(profileId);
      const result = await get(url, {}, { suppressGlobalNotification: true });
      dispatch(setData(result.data.filter(entry => entry.id !== profileId)));
    } catch (error) {
      dispatch(danger(__t('influencer_agency_profiles_reducer.error')));
    } finally {
      dispatch(setLoadingStatus(AgencyProfilesLoadingState.loaded));
    }
  };
}

export default createReducer<AgencyProfilesReduxState, any>('influencerAgencyProfiles', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [SET_LOADING_STATUS]: (state, { loadingStatus }) => ({
    ...state,
    loadingStatus
  }),
  [SET_RESPONSE_DATA]: (state, { data = [] }) => ({
    ...state,
    profiles: data
  })
});
